import PageDefault from "./pages/PageDefault";
import PageHome from "./pages/PageHome";
import PageSingle from "./pages/PageSingle";
import PageSearch from "./pages/PageSearch";
import Navigation from "./components/Navigation";
import { debounce } from "./inc/helpers";
import PageSingleServizio from "./pages/PageSingleServizio";
import PageNewsList from "./pages/PageNewsList";
import Loader from "./components/Loader";
import CommonBlocks from "./components/CommonBlocks";
import PageSingleSoluzione from "./pages/PageSingleSoluzione";
import PageParts from "./pages/PageParts";
import PageSingleOpenPosition from "./pages/PageSingleOpenPosition";
import PageSocialResp from "./pages/PageSocialResp";
import PageLanding80 from "./pages/PageLanding80";

export default class app {
  constructor({ template, data, data_flyout_menu, postsPerPage, relatedArticles }) {
    this.template = template;
    this.data = data;
    this.relatedArticles = relatedArticles ?? [];
    this.data_flyout_menu = data_flyout_menu;
    this.page = null;
    this.nav = null;
    this.postsPerPage = postsPerPage;
    this.loader = new Loader({ minimumTime: 1000, cssClass: "js-loader" });
  }

  init() {
    this.init_nav();
    this.init_page_props();
    
    const handleResize = debounce((e) => this.init_page_props());
    window.addEventListener("resize", handleResize);
    
    this.init_page_template();    
    this.page.init(this.data);
    this.init_common_blocks();

    //console.log(this.template, this.data, this.data_flyout_menu);
  }

  init_page_template() {
    if (this.template === "home") {
      this.page = new PageHome();
    
    } else if (this.template === "single") {
      this.page = new PageSingle();
    
    } else if (this.template === "single-servizio") {
      this.page = new PageSingleServizio();
    
    } else if (this.template === "search") {
      this.page = new PageSearch();
      this.page.template = this.template;
      this.page.postsPerPage = this.postsPerPage;
      this.page.relatedArticles = this.relatedArticles;
    
    } else if (this.template === "news") {
      this.page = new PageNewsList({
        template: this.template,
        postsPerPage: this.postsPerPage,
        data: this.data,
        loader: this.loader,
      });
    
    } else if (this.template === "single-soluzione") {
      this.page = new PageSingleSoluzione();
    
    } else if (this.template === "ricambi") {
      this.page = new PageParts();
    
    } else if (this.template === "single-open-position") {
      this.page = new PageSingleOpenPosition();
    
    } else if (this.template === "social-resp") {
      this.page = new PageSocialResp();
    
    } else if (this.template === "landing-80") {
      this.page = new PageLanding80();

    } else {
      this.page = new PageDefault();
    }
  }

  init_common_blocks() {
    const blocks = new CommonBlocks();
    blocks.init();
  }

  init_nav() {
    this.nav = new Navigation(this.data_flyout_menu);
    this.nav.init();
  }

  init_page_props() {
    document.documentElement.style.setProperty("--vw", `${window.innerWidth}px`);
    document.documentElement.style.setProperty("--vh", `${window.innerHeight}px`);
    document.documentElement.style.setProperty("--nav-h", `${this.nav.nav_h}px`);
  }
}
